module.exports = __webpack_public_path__ + "img/icon-sales-person.7a959d12.svg";